import React from 'react';
import styles from './index.modules.scss';
/**
 * Radio，只改变其颜色，参照：https://mantine.dev/core/radio/
 * @param {*} props
 * @returns
 */
export const Radio = (props) => {
  const { className, checked, ...rest } = props;
  return (
    <div {...rest} className={`${styles.radio} ${className} `}>
      <div
        className={styles.checked}
        style={{
          top: checked ? 0 : 13,
        }}
      ></div>
    </div>
  );
};
